import Vue from 'vue';
import Router from 'vue-router';
import routers from './systemRouters.js';
import dialog from '@/components/Dialog';
import { getToken } from '@/utils';

Vue.use(Router)

// 未防止覆盖在这添加自定义路由
const _import = require('./import-' + process.env.NODE_ENV)
routers.push(
  {path: '/analysis/leader', component: _import('analysis/leader/index'), name: 'leader', desc: '领导驾驶舱' },
  {path: '/analysis/bigScreen', component: _import('bigScreen/index'), name: 'bigScreen', desc: '驾驶舱' }
)

const router = new Router({
  mode: 'history',
  base: '/npkt',
  routes: routers
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(e => {});
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push (location, onComplete, onAbort) {
  return originalReplace.call(this, location, onComplete, onAbort).catch(e => {});
}

/**
 * 路由跳转的时候判断token是否存在
 */
router.beforeResolve((to, from, next) => {
  if (to.name === 'login' || to.name === 'register' || to.name === 'findPassword') {
    next();
  } else {
    let token = getToken();
    if (!token || !/\S/.test(token)) {
      dialog.closeAll();
      next({ name: 'login' })
    } else {
      next();
    }
  }
});

export default router;
